export const isScaleWeightMetricUnit = (metricUnit) =>
  /kg/i.test(String(metricUnit || '').toLowerCase());

export const formatScaleWeight = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return `${numeric.toFixed(3)} kg`;
};

const getScaleModeLabel = (scaleReadingStrategy) => {
  if (scaleReadingStrategy === 'direct_stable') return 'estable directa';
  if (scaleReadingStrategy === 'app_stabilized') return 'continua estabilizada';
  return 'activa';
};

export const buildScaleReadingBadge = (scaleState, { enabled = false } = {}) => {
  if (!enabled) return null;

  const freshWeightLabel = formatScaleWeight(scaleState?.freshStableWeightKg);
  if (freshWeightLabel) {
    return {
      kind: 'fresh',
      tone: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      label: `Balanza ${getScaleModeLabel(scaleState?.scaleReadingStrategy)}: ${freshWeightLabel}`,
      weightLabel: freshWeightLabel,
    };
  }

  if (scaleState?.hasLiveScaleStream && scaleState?.scaleReadingStrategy === 'direct_stable') {
    return {
      kind: 'waiting_direct',
      tone: 'bg-blue-50 text-blue-700 border-blue-200',
      label: 'Esperando un peso estable distinto de cero',
      weightLabel: null,
    };
  }

  if (scaleState?.hasLiveScaleStream && scaleState?.scaleReadingStrategy === 'app_stabilized') {
    return {
      kind: 'waiting_stabilized',
      tone: 'bg-blue-50 text-blue-700 border-blue-200',
      label: 'Esperando estabilidad de la balanza',
      weightLabel: null,
    };
  }

  if (scaleState?.status === 'disconnected' || scaleState?.connectionStatus === 'disconnected') {
    return {
      kind: 'disconnected',
      tone: 'bg-amber-50 text-amber-700 border-amber-200',
      label: 'Balanza desconectada',
      weightLabel: null,
    };
  }

  if (scaleState?.connectionStatus === 'connecting') {
    return {
      kind: 'connecting',
      tone: 'bg-blue-50 text-blue-700 border-blue-200',
      label: 'Esperando lectura de balanza',
      weightLabel: null,
    };
  }

  if (scaleState?.status === 'registered') {
    return {
      kind: 'registered',
      tone: 'bg-blue-50 text-blue-700 border-blue-200',
      label: 'Equipo autorizado, esperando la app de balanza',
      weightLabel: null,
    };
  }

  if (scaleState?.status === 'unpaired') {
    return {
      kind: 'unpaired',
      tone: 'bg-gray-50 text-gray-600 border-gray-200',
      label: 'Sin balanza emparejada',
      weightLabel: null,
    };
  }

  const staleWeightLabel = formatScaleWeight(scaleState?.latestStableWeightKg);
  if (staleWeightLabel) {
    return {
      kind: 'stale',
      tone: 'bg-gray-50 text-gray-600 border-gray-200',
      label: `Ultima lectura vencida: ${staleWeightLabel}`,
      weightLabel: staleWeightLabel,
    };
  }

  return {
    kind: 'waiting_default',
    tone: 'bg-blue-50 text-blue-700 border-blue-200',
    label: 'Coloca el producto en la balanza',
    weightLabel: null,
  };
};
